import { render } from "./Recurrency.vue?vue&type=template&id=20d2af6b&ts=true"
import script from "./Recurrency.vue?vue&type=script&lang=ts"
export * from "./Recurrency.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__